'use client';

import React from 'react';
import { RecoilRoot } from 'recoil';
import { domAnimation, LazyMotion } from 'framer-motion';
import { ExperimentProvider } from '@/contexts/amplitude';
import { AmplitudeClients } from '../hooks/useAmplitude';
import { InboundProvider } from '@/contexts/inbound';
import { InboundDrawerProvider } from '@/contexts/inboundDrawer';
import { QRCodeDrawerProvider } from '@/contexts/qrcodeDrawer';
import { ReCaptchaProvider } from 'next-recaptcha-v3';
import { PlansProvider } from '@/contexts/plans';
import { FormInboundProvider } from '@/contexts/formInbound';
import { ShowCalculatorProvider } from '@/contexts/showCalculator';
import StyledComponentsProvider from '@/components/StyledComponent';

interface Props {
  children: React.ReactNode;
  amplitudeClients: AmplitudeClients;
}

/** TODO(@gabrieldissotti) Se a página não tiver nenhum experimento em nenhum componente dá pra não baixar esse script ExperimentProvider, mas se por acaso colocarem experimento via código em algum botão por exmeplo não iria funcionar sem o provider. */
export default function Providers({ children, amplitudeClients }: Props) {
  return (
    <RecoilRoot>
      <LazyMotion features={domAnimation}>
        <StyledComponentsProvider>
          <ExperimentProvider value={amplitudeClients}>
            <InboundProvider>
              <InboundDrawerProvider>
                <QRCodeDrawerProvider>
                  <ReCaptchaProvider
                    useRecaptchaNet
                    useEnterprise
                    reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY}
                  >
                    <PlansProvider>
                      <FormInboundProvider>
                        <ShowCalculatorProvider>
                          {children}
                        </ShowCalculatorProvider>
                      </FormInboundProvider>
                    </PlansProvider>
                  </ReCaptchaProvider>
                </QRCodeDrawerProvider>
              </InboundDrawerProvider>
            </InboundProvider>
          </ExperimentProvider>
        </StyledComponentsProvider>
      </LazyMotion>
    </RecoilRoot>
  );
}
